module.exports = __webpack_public_path__ + "img/en.da08e077.svg";